module.exports = __webpack_public_path__ + "static/media/map_marker_inactive.b057b337.svg";